import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadSpinnerService {
  private subject = new Subject<boolean>();
  private lock = false;
  private counter = 0;

  constructor() {}

  lockSpinner() {
    this.lock = true;
  }

  unlockSpinner() {
    this.lock = false;
  }

  getSpinner(): Observable<boolean> {
    return this.subject.asObservable();
  }

  showSpinner() {
    if (this.lock) {
      return;
    }
    this.counter++;
    this.subject.next(true);
  }

  hideSpinner() {
    if (this.lock) {
      return;
    }
    this.counter--;
    if (this.counter < 0) {
      this.counter = 0;
    }
    if (this.counter === 0) {
      this.subject.next(false);
    }
  }
}
